import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-RSYA",
  "use": "svg-icon-RSYA-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"svg-icon-RSYA\"><path d=\"M10 7V1h6v6h-6zM0 11V8.999h16V11H0zm0-4V5h8v2H0zm0-4V.999h8V3H0zm0 12v-2h16v2H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol